export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },

    openDoctorForm({commit}) {
        commit('setDoctorFormOpen');
    },
    closeDoctorForm({commit}) {
        commit('setDoctorFormClose');
    },

    openExamForm({commit}) {
        commit('setExamFormOpen');
    },
    closeExamForm({commit}) {
        commit('setExamFormClose');
    },
    openExamGrid({commit}) {
        commit('setExamGridOpen');
    },
    closeExamGrid({commit}) {
        commit('setExamGridClose');
    },

    openLanguageForm({commit}) {
        commit('setLanguageFormOpen');
    },
    closeLanguageForm({commit}) {
        commit('setLanguageFormClose');
    },
    openLanguageGrid({commit}) {
        commit('setLanguageGridOpen');
    },
    closeLanguageGrid({commit}) {
        commit('setLanguageGridClose');
    },

    openFeeForm({commit}) {
        commit('setFeeFormOpen');
    },
    closeFeeForm({commit}) {
        commit('setFeeFormClose');
    },
    openFeeGrid({commit}) {
        commit('setFeeGridOpen');
    },
    closeFeeGrid({commit}) {
        commit('setFeeGridClose');
    },
}
